const refs = 'auth'
export default [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/" + refs + "/Login.vue"),
    beforeEnter: requireUnAuth,
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/" + refs + "/Register.vue"),
    beforeEnter: requireUnAuth,
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("@/views/" + refs + "/Profile.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: "/profile",
    name: "me",
    component: () => import("@/views/" + refs + "/Profile.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: "/shares",
    name: "Shares",
    component: () => import("@/views/" + refs + "/Shares.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: "/verify",
    name: "verify",
    component: () => import("@/views/" + refs + "/Verify.vue"),
    beforeEnter: requireUnAuth,
  },
  {
    path: "/forget/password",
    name: "forget",
    component: () => import("@/views/" + refs + "/Forget.vue"),
    beforeEnter: requireUnAuth,
  },
  {
    path: "/reset/password",
    name: "reset",
    component: () => import("@/views/" + refs + "/Reset.vue"),
    beforeEnter: requireUnAuth,
  },
];



function requireUnAuth(to, from, next) {
  //store.dispatch('fetchAccessToken');
  // if (store.state.accessToken) { next('/'); } 
  // else { next(); }
  if (localStorage.getItem('access_token')) { next('/'); }
  else { next(); }
  //next();
}


function requireAuth(to, from, next) {
  // store.dispatch('fetchAccessToken');
  // if (!store.state.accessToken) { next('/auth/login'); }
  // else { next(); }
  if (!localStorage.getItem("access_token")) {
    next("/auth/login");
  } else {
    next();
  }
  //next();
}